import React from "react";
import { FaWallet, FaLock, FaComments, FaShieldAlt } from "react-icons/fa";

function OperationalEfficiency() {
  return (
    <>
      <div
        className="process-style-three-area default-padding bg-dark text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">How it works</h4>
                <h2 className="title split-text-right split-text-in-right">
                  What Security We Offer With Our Margin Trading Exchange
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-2">
              <div className="process-style-three-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaWallet size={48} />
                  </div>
                  <h4>Wallet Security</h4>
                  <p>
                    We employ multi-signature withdrawal mechanisms to enhance
                    wallet security, ensuring that only authorized users can
                    access and transfer funds, significantly reducing the risk
                    of unauthorized transactions.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaLock size={48} />
                  </div>
                  <h4>System Security</h4>
                  <p>
                    Our platform utilizes multi-level authentication protocols,
                    providing an added layer of protection against unauthorized
                    access and ensuring that user accounts remain secure at all
                    times.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaComments size={48} />
                  </div>
                  <h4>Communication Security</h4>
                  <p>
                    We implement high-level encryption for all communications
                    within the platform, safeguarding sensitive data and
                    ensuring that user interactions remain confidential and
                    protected from potential threats.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationalEfficiency;
